import { everyTrue } from 'aa_common/front-end/helpers'
import { tryCallApi } from 'common/helpers'
import { DepreciationResultAdjustHistoryService } from 'common/open-api'
import moment from 'moment'

// Whether the last event falls in a later month than the monthly closing period accelerated depreciation was registered
// in; the same month gives priority to the accelerated depreciation reason. False when unknown or the API fails.
export const checkIsEventAfterAdjusted = async (biid: string) => {
  const response = await tryCallApi(DepreciationResultAdjustHistoryService.getDepreciationResultsAdjustHistoryByBiid)(
    biid
  )
  const adjustedAt = response.data?.data?.monthly_closing?.from_term_month?.start_date
  const lastEventValidFrom = response.data?.data?.last_fa_event?.valid_from
  return everyTrue(!!adjustedAt, !!lastEventValidFrom, moment(lastEventValidFrom).isAfter(adjustedAt, 'month'))
}
